module.exports = __webpack_public_path__ + "img/ico-mitsuigardenhotels.b26e0367.jpg";